import { Dispatch, SetStateAction } from "react";
import { Beer } from "../../../data/types";
import "./Sortable.scss";
import { DndContext, DragEndEvent, closestCenter } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import SortableItem from "./SortableItem";
import { updateBeerOrder } from "../../../services/firestore";

interface BeerListProps {
  beers: Beer[];
  setBeers: Dispatch<SetStateAction<Beer[]>>;
  // onEdit: (updatedBeer: Beer) => void;
  onDelete: (id: string) => void;
}

const SortableBeerList: React.FC<BeerListProps> = ({
  beers,
  /* onEdit, */ onDelete,
  setBeers,
}) => {
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setBeers((prev) => {
      const oldIndex = prev.findIndex((b) => b.id === active.id);
      const newIndex = prev.findIndex((b) => b.id === over.id);
      const newOrder = arrayMove(prev, oldIndex, newIndex);

      // Sätt nytt order-fält baserat på position
      const updated = newOrder.map((beer, index) => ({
        ...beer,
        order: index,
      }));

      // Uppdatera i Firestore
      updated.forEach((beer) => {
        updateBeerOrder(beer.id, beer.order);
      });

      return updated;
    });
  };

  return (
    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext
        items={beers.map((beer) => beer.id)}
        strategy={verticalListSortingStrategy}
      >
        <ul className="beer-list">
          {beers.map((beer) => (
            <SortableItem
              key={beer.id}
              beer={beer}
              onDelete={onDelete}
              setBeers={setBeers}
            />
          ))}
        </ul>
      </SortableContext>
    </DndContext>
  );
};

export default SortableBeerList;
